import Mock from 'mockjs';

Mock.setup({
  timeout: '10-1500',
});

export default Mock;
